"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleLogProviderInstance = exports.ConsoleLogProvider = void 0;
var entry_prefix_1 = require("../helpers/entry-prefix");
/**
 * Wrapper for browser console
 */
var ConsoleLogProvider = /** @class */ (function () {
    function ConsoleLogProvider() {
        this.isIE = typeof document !== 'undefined' && !!document.documentMode;
        this.isEdge = typeof navigator !== 'undefined' && !!navigator.userAgent && /Edge/.test(navigator.userAgent);
        /**
         * browser ability to apply styles to log message
         */
        this.canStyleLogMessage = !(this.isIE || this.isEdge);
    }
    ConsoleLogProvider.prototype.log = function (configuration, debugByTagPool, severity, method, message, tags, args) {
        // Runs console method if severity threshold met or tag matches were found
        if (severity >= configuration.thresholdLevel ||
            (tags.length > 0 && tags.some(function (tag) { return debugByTagPool.indexOf(tag) > -1; }))) {
            // build console entry prefix - console will use browser date primary usage,
            var prefix = entry_prefix_1.buildEntryPrefix(configuration.messagePrefix || '', new Date());
            var consoleArgs = this.canStyleLogMessage
                ? [
                    "%c" + prefix + " %c " + message,
                    "color: " + configuration.messagePrefixColor,
                    "color: " + configuration.messageColor
                ]
                : ["[" + prefix + "] " + message];
            // add arguments
            consoleArgs.push.apply(consoleArgs, args);
            console[method].apply(console, consoleArgs);
        }
    };
    return ConsoleLogProvider;
}());
exports.ConsoleLogProvider = ConsoleLogProvider;
/**
 * Exports instance of ConsoleLogProvider
 * to use as the singleton reference for default provider in VistaDiagnosticsLog
 */
exports.consoleLogProviderInstance = new ConsoleLogProvider();
//# sourceMappingURL=console.js.map